import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';
import { StepProps } from 'antd';
import { validateRolesTab } from '../Projects.Constructor.Roles';
import { validateEmployeesTab } from '../Projects.Constructor.Employees';
import { validateEpicsTab } from '../Projects.Constructor.Epics';
import { validateEpicGroupsTab } from '../Projects.Constructor.EpicGroups';
import { validateColumnsTab } from '../Projects.Constructor.Columns';
import { validateTablesTab } from '../Projects.Constructor.Tables';
import { validateSheetsTab } from '../Projects.Constructor.Sheets';
import { validateConstructor } from '../helpers';

export type StepPropsType = StepProps & {
  key: string;
};

export const tabNames = {
  positions: 'positions',
  employees: 'employees',
  epics: 'epics',
  epicGroups: 'epicGroups',
  columns: 'columns',
  tables: 'tables',
  sheets: 'sheets',
};

export const tabsSettings = [
  {
    tabName: tabNames.positions,
    nameTKey: 'menu.roles',
    validateFunction: validateRolesTab,
    description: '',
  },
  {
    tabName: tabNames.employees,
    nameTKey: 'menu.employees',
    validateFunction: validateEmployeesTab,
    description: '',
  },
  {
    tabName: tabNames.epics,
    nameTKey: 'menu.epics',
    validateFunction: validateEpicsTab,
    description: '',
  },
  {
    tabName: tabNames.epicGroups,
    nameTKey: 'menu.products',
    validateFunction: validateEpicGroupsTab,
    description: '(Optional)',
  },
  {
    tabName: tabNames.columns,
    nameTKey: 'menu.columns',
    validateFunction: validateColumnsTab,
    description: '',
  },
  {
    tabName: tabNames.tables,
    nameTKey: 'menu.tables',
    validateFunction: validateTablesTab,
    description: '',
  },
  {
    tabName: tabNames.sheets,
    nameTKey: 'menu.sheets',
    validateFunction: validateSheetsTab,
    description: '',
  },
];

const getTabSettingsByName = (name: string) => {
  return tabsSettings.find((tab) => tab.tabName === name)!;
};

export const useMenuItems = (projectData: ProjectDto) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const validator = validateConstructor(projectData);

  return Object.values(tabNames).map((name: string) => {
    const { tabName, description, nameTKey } = getTabSettingsByName(name);
    return {
      key: tabName,
      description,
      title: t(nameTKey),
      disabled: !validator[name].isStepAvailable,
      status:
        (projectData.isCompleted || tabName === tabNames.epicGroups) && !validator[name].isValid
          ? 'error'
          : undefined,
    } as StepPropsType;
  });
};
